import * as React from 'react';
import { GridCellProps } from '@progress/kendo-react-grid';
import { Input } from 'reactstrap';
import { Error } from "@progress/kendo-react-labels";

class DragCell<T> extends React.Component<GridCellProps & {
    reorder: (item: T) => void;
    dragStart: (item: T) => void;
    dragEnd: (item: T) => void;
}, {}> {
    render() {
        return (
            <td onDragOver={(e) => {
                //console.log('on onDragOver', this.props.dataItem);
                this.props.reorder(this.props.dataItem as T);
                e.preventDefault();
                e.dataTransfer.dropEffect = "move";
            }}
                onDragEnd={(e) => {
                    this.props.dragEnd(this.props.dataItem as T);
                    console.log('onDragEnd', this.props.dataItem as T);
                }}
                onDragExit={(e) => {
                    console.log('onDragExit', this.props.dataItem as T);
                }}
            >
                <span
                    className="k-icon k-i-reorder"
                    draggable={true}
                    style={{ cursor: 'move' }}
                    onDragStart={(e) => {
                        console.log('on onDragStart', this.props.dataItem);
                        this.props.dragStart(this.props.dataItem as T);
                        e.dataTransfer.setData("dragging", "");
                    }}
                />
            </td>
        );
    }
}

export { DragCell }

const CustomInput = fieldRenderProps => {
    const { validationMessage, visited, modified, touched, ...others } = fieldRenderProps;
    return (
        <div>
            <Input {...others} />
            {visited && validationMessage && <Error>{validationMessage}</Error>}
        </div>
    );
};

export { CustomInput };